import { CONTESTS_SHOW_SUCCESS } from '../actions/contests';
import oget from 'oget';

const defaultState = [];

export default (state = defaultState, { type, payload = {} }) => {
  switch (type) {
    case CONTESTS_SHOW_SUCCESS: {
      const { selectedRound } = payload;

      return oget(selectedRound, 'heats', []);
    }

    default: {
      return state;
    }
  }
};
